import WithRender from "../../templates/layouts/layoutStock.html";

export default WithRender({});
